var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKakao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 9298",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10169"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38586",
    d: "M61.075 103.272a1.186 1.186 0 0 1-.943-.451 1.507 1.507 0 0 1-.2-1.348c.113-.449.555-2.11.969-3.657a13 13 0 0 1-4.258-3.7 9.845 9.845 0 0 1-1.92-5.769A10.448 10.448 0 0 1 59 80.137a16.914 16.914 0 0 1 20.065 0 10.021 10.021 0 0 1 0 16.414 16.181 16.181 0 0 1-10.032 3.3 17.954 17.954 0 0 1-2.252-.142c-1.475 1-4.626 3.145-4.853 3.3a1.554 1.554 0 0 1-.853.263zm7.953-24.557c-6.853 0-12.428 4.319-12.428 9.629 0 3.319 2.174 6.365 5.815 8.147l.693.339-.2.745-.812 3.043 3.924-2.667.3-.206.362.054a16.053 16.053 0 0 0 2.344.172c6.853 0 12.428-4.32 12.428-9.629s-5.573-9.627-12.426-9.627z",
    transform: "translate(-54.029 -75.056)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38590",
    d: "M109.351 185.247h-3.909a.665.665 0 1 0 0 1.329h1.271v4.682a.65.65 0 0 0 .648.648h.142a.65.65 0 0 0 .647-.648v-4.682h1.2a.665.665 0 1 0 0-1.329",
    transform: "translate(-99.728 -175.071)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38590 - \\uC724\\uACFD\\uC120",
    d: "M107.515 191.982h-.142a.713.713 0 0 1-.711-.711v-4.62h-1.208a.727.727 0 1 1 0-1.454h3.909a.727.727 0 1 1 0 1.454h-1.138v4.62a.712.712 0 0 1-.71.711zm-2.061-6.66a.6.6 0 1 0 0 1.2h1.333v4.745a.588.588 0 0 0 .586.586h.142a.587.587 0 0 0 .585-.586v-4.745h1.263a.6.6 0 1 0 0-1.2z",
    transform: "translate(-99.741 -175.084)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38587",
    d: "M262.67 189.4h-1.817v-4.782a.721.721 0 1 0-1.442 0v5.154a.688.688 0 0 0 .011.115.615.615 0 0 0-.011.115.6.6 0 0 0 .6.6h2.656a.6.6 0 0 0 0-1.207",
    transform: "translate(-243.657 -173.812)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38587 - \\uC724\\uACFD\\uC120",
    d: "M262.682 190.68h-2.656a.665.665 0 0 1-.655-.782.718.718 0 0 1-.01-.115v-5.154a.784.784 0 1 1 1.567 0v4.719h1.755a.666.666 0 0 1 0 1.332zm-2.538-6.711a.66.66 0 0 0-.659.659v5.154a.63.63 0 0 0 .01.105v.022a.54.54 0 0 0 .531.645h2.656a.541.541 0 0 0 0-1.082H260.8v-4.844a.659.659 0 0 0-.656-.659z",
    transform: "translate(-243.669 -173.824)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38588",
    d: "m325.828 189.617-2.025-2.66 1.83-1.831a.635.635 0 1 0-.9-.9l-2.265 2.266v-1.878a.721.721 0 1 0-1.442 0v5.313a.721.721 0 1 0 1.442 0v-1.639l.412-.411 1.916 2.514a.645.645 0 1 0 1.031-.775",
    transform: "translate(-301.01 -173.812)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38588 - \\uC724\\uACFD\\uC120",
    d: "M325.326 190.725a.71.71 0 0 1-.566-.283l-1.872-2.457-.343.343v1.613a.784.784 0 1 1-1.567 0v-5.313a.784.784 0 1 1 1.567 0v1.728l2.155-2.156a.7.7 0 1 1 .986.986l-1.791 1.792 1.992 2.617a.709.709 0 0 1-.141.991.7.7 0 0 1-.42.139zM322.9 187.8l1.959 2.571a.585.585 0 0 0 .467.234.574.574 0 0 0 .349-.117.584.584 0 0 0 .116-.816l-2.058-2.7 1.869-1.869a.572.572 0 0 0-.81-.809l-2.372 2.372v-2.029a.659.659 0 1 0-1.317 0v5.313a.659.659 0 1 0 1.317 0v-1.665z",
    transform: "translate(-301.023 -173.824)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38589",
    d: "m173.6 189.789-1.948-5.329-.006-.006a.957.957 0 0 0-.913-.561.93.93 0 0 0-.947.671.88.88 0 0 0-.037.088l-1.915 5.137a.646.646 0 1 0 1.219.428l.331-.946h2.666l.331.946a.646.646 0 1 0 1.219-.428m-3.793-1.725.9-2.556h.029l.9 2.553z",
    transform: "translate(-158.392 -173.81)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 38589 - \\uC724\\uACFD\\uC120",
    d: "M173.006 190.724a.71.71 0 0 1-.669-.474l-.317-.9h-2.577l-.317.9a.709.709 0 1 1-1.337-.47l1.916-5.138a.866.866 0 0 1 .036-.086.991.991 0 0 1 1.007-.713 1.023 1.023 0 0 1 .966.588l.007.007.005.014 1.948 5.329a.709.709 0 0 1-.668.945zm-3.651-1.5h2.755l.346.988a.584.584 0 1 0 1.1-.387l-1.942-5.313-.006-.005-.005-.014a.894.894 0 0 0-.854-.521.865.865 0 0 0-.886.621v.014a.828.828 0 0 0-.035.081l-1.916 5.139a.584.584 0 0 0 1.1.386zm2.375-1.082h-2l.939-2.681h.111l.02.043zm-1.82-.125h1.643l-.822-2.344z",
    transform: "translate(-158.404 -173.823)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKakao);
export default __webpack_public_path__ + "static/media/icon_kakao.746d6d9a5191302d37a8b866c6b1fbad.svg";
export { ForwardRef as ReactComponent };